// 默认头像：用户名首字 + 随机渐变色块，纯本地生成（SVG data URI），不依赖外部服务
// 同一用户（同 id / username）始终得到相同配色，确定性可复现

// 精选渐变色对（饱和 / 偏深，保证白色首字清晰可读）
const GRADIENTS = [
  ['#667eea', '#764ba2'], // 紫蓝
  ['#f5576c', '#f093fb'], // 粉紫
  ['#4facfe', '#00f2fe'], // 青蓝
  ['#11998e', '#38ef7d'], // 翠绿
  ['#f12711', '#f5af19'], // 橙红
  ['#7f00ff', '#e100ff'], // 紫红
  ['#4b6cb7', '#182848'], // 深蓝
  ['#ee0979', '#ff6a00'], // 粉橙
  ['#2193b0', '#6dd5ed'], // 海蓝
  ['#c31432', '#240b36'], // 深红紫
  ['#1e3c72', '#2a5298'], // 靛蓝
  ['#e53935', '#e35d5b'], // 砖红
]

// 字符串 → [0, mod) 的稳定哈希索引
function hashIndex(str, mod) {
  let h = 0
  const s = String(str)
  for (let i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) >>> 0
  }
  return mod ? h % mod : 0
}

// 取用户名首字：中文 / emoji / 数字取原字符，英文取大写首字母
function getInitial(username) {
  const s = String(username || '').trim()
  if (!s) return '?'
  const ch = Array.from(s)[0]
  return /[a-z]/.test(ch) ? ch.toUpperCase() : ch
}

// 转义 XML 特殊字符，防止首字破坏 SVG 结构
function escapeXml(s) {
  return s.replace(/[<>&'"]/g, (ch) => (
    { '<': '&lt;', '>': '&gt;', '&': '&amp;', "'": '&apos;', '"': '&quot;' }[ch]
  ))
}

/**
 * 生成本地默认头像（首字母渐变），返回 SVG data URI，可直接用作 <img :src>
 * @param {string} username 用户名，用于取首字
 * @param {string|number} seed 配色种子（建议传用户 id）；为空时退化为 username
 */
export function defaultAvatar(username, seed) {
  const initial = escapeXml(getInitial(username))
  const [c1, c2] = GRADIENTS[hashIndex(seed ?? username ?? '', GRADIENTS.length)]
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80">
<defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="${c1}"/><stop offset="1" stop-color="${c2}"/></linearGradient></defs>
<rect width="80" height="80" fill="url(#g)"/>
<text x="50%" y="50%" dy=".35em" text-anchor="middle" font-family="-apple-system,BlinkMacSystemFont,'Segoe UI','PingFang SC','Microsoft YaHei',sans-serif" font-size="38" font-weight="600" fill="#fff">${initial}</text>
</svg>`
  return 'data:image/svg+xml,' + encodeURIComponent(svg)
}
